import styled from "styled-components";

const Image = styled.div<Image.Props>`
	width: 100%;
	height: 100%;

	background: no-repeat center;
	background-size: ${({ fit = "cover" }) => fit};
	background-color: ${({ fit = "cover" }) =>
		fit === "contain" ? "#f3f5f7" : "black"};
	background-image: url(${({ url }) => url});

	overflow: hidden;
`;

declare namespace Image {
	interface Props {
		url: string;
		fit?: "cover" | "contain";
	}
}

export default Image;
